// ============================================================================= //
//  Dependencies
// ============================================================================= //
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// ============================================================================= //
//  Process
// ============================================================================= //

const projectReels = document.querySelectorAll('.process');

if ( projectReels.length ) {
	projectReels.forEach( (section) => {

		const processSteps = section.querySelectorAll('.process__step');

		const animation = gsap.timeline({
			defaults: {
			  duration: 2,
			  ease: "power2.inOut",
			},
			repeat: -1, // Powtórz animację w nieskończoność
			repeatDelay: 1.5 // Opoźnienie x sekundy przed kolejną iteracją
		  });

		if ( processSteps.length ) {
			processSteps.forEach( (el) => {

				animation.to(
					el, {
						"--width": "100%",
						onStart: function() {
							el.classList.add('is-animating');
						},
						// onComplete: function() {
						// 	el.classList.add('is-completed');
						// },
						onReverseComplete: function() {
							el.classList.remove('is-animating');
							//el.classList.remove('is-completed');
						},
						stagger: 5
					}
				)

			});
		}

	});
}
